import React from 'react'
import { CCard, CCardBody, CCardGroup, CCol, CContainer, CRow } from '@coreui/react-pro'
import { LoginForm } from 'components'
import logo from '../../../assets/brand/RCYCLE_Logo_green_blue-400x.png'

import { getStageName } from 'utils/helpers'

const Login = (props) => {
  return (
    <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol sm={12} lg={8} xl={6}>
            <div
              className="d-flex align-items-center justify-content-center p-4 login-header"
              style={{ backgroundColor: `#eef4f4` }}
            >
              <div className="position-relative">
                <img src={logo} alt={`Login_logo`} height="50" />
                <span className={`brand-sub ${getStageName()}`}>{getStageName()}</span>
              </div>
            </div>
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <LoginForm />
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default Login
